import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import pkg from './package.json';

export const AccountsGrid = globalContext.define(
  [...pkg.legacyDependencies, ...pkg.indexOnlyDependencies],
  Promise => import(/* webpackMode: 'eager' */ './src/index') // eslint-disable-line no-unused-vars
);

export { getSharedColumnConfiguration } from './src/columns/shared-column-configuration';

export const getAccountsGridFactory = (initializeGlobalContext = true) => {
  if (initializeGlobalContext) {
    return globalContext.define(
      pkg.legacyDependencies,
      Promise => import(/* webpackMode: 'eager' */ './src/accounts-grid-factory') // eslint-disable-line no-unused-vars
    );
  }
  return import(/* webpackMode: 'eager' */ './src/accounts-grid-factory'); // eslint-disable-line no-unused-vars
};

export { gridsType, gridsMap } from './src/constants';
export { ScheduledImportPopup } from './src/helper/scheduled-import-popup';
